import { atom, useAtom } from "jotai";
import { State } from "./State";
import { fetchBase } from "./BaseApi";

export type Gift = {
  giftNo: number;
  giftId: string;
  giftType: "event" | "certificate";
  effectiveFrom: string;
  effectiveTo: string;
  giftName: string;
  requiredPoint: number;
  giftImage: string;
};

export type GiftParam = {
  giftType?: string;
  giftId?: string;
};

const uri = "api/gift";

export type GiftResponse = { giftList: Gift[] };
export const fetchGiftAtom = atom<State<GiftResponse> | null>(null);
export const fetchGift = () => {
  return fetchBase<GiftResponse, GiftParam>(uri, fetchGiftAtom);
};
